<app-skeleton [loading]="loading" height="220px">
    <app-source-detail [baseInfo]="baseInfo"
        [detail]="detail"
        [event]="item"
        [loading]="updateLoading"
        [showPercentBar]="false"
        [vstoreName]="detail.vstoreName"
        icon="#infigo-logicPort"
    >
    </app-source-detail>
</app-skeleton>
